import { Component, OnInit, Input } from '@angular/core';
import { PlayerService } from '../../../services/player.service';
import { Subscription } from '../../../objects/subscription';
import { MatDialog } from '@angular/material/dialog';
import { CreateAccountComponent } from '../../../components/create-account/create-account.component';
import { Router } from '@angular/router';


@Component({
  selector: 's18-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss']
})
export class CalculatorComponent implements OnInit {
  @Input() calculatorOnly: boolean = false;
  calculatingMatch: boolean = false;
  loggedIn: boolean = false;

  subscriptionPriceList: Subscription[];
  match : Subscription;
  costPerMember: number = 0;
  costPerEvent: number = 0;
  
  
  calculator : {
    playersInGroup: number;
    eventsPerYear: number;
    playersPerEvent: number;
  } = { playersInGroup: 0, eventsPerYear: 0, playersPerEvent: 0 } ;

  constructor(
    private playerService: PlayerService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    if ( this.playerService.getLoggedInPlayerInfo()){
      this.loggedIn = true;
    }
  }

  calculateMatch(){
    this.calculatingMatch = true;
    var groupType = 0;
    if ( this.calculator.playersPerEvent < 5){
      groupType = 0;
    }else if ( this.calculator.playersPerEvent > 4 && this.calculator.playersPerEvent < 9){
      groupType = 0;
    }else if ( this.calculator.playersPerEvent> 8 && this.calculator.playersPerEvent < 17){
      groupType = 1;
    }else if ( this.calculator.playersPerEvent> 16){
      groupType = 2;
    }
    if ( this.calculator.eventsPerYear > 0 && this.calculator.eventsPerYear < 2 ){
      groupType = 4;
    }else if ( this.calculator.eventsPerYear > 2 && this.calculator.eventsPerYear < 5 ){
      groupType = 5;
    }

    this.playerService.getSubscriptionPriceList(groupType.toString())
      .subscribe( resp => {
        this.subscriptionPriceList = JSON.parse(resp.d).priceList;
        this.subscriptionPriceList.forEach( x => {
          if ( x.max_foursome == 0){
            x.max_foursome = 38;
          }
        });
        this.match = this.subscriptionPriceList.filter( x => x.max_foursome*4 >= this.calculator.playersPerEvent)[0];
        if ( [1,2].indexOf(groupType) > -1){
          this.costPerMember = this.match.price*12/this.calculator.playersInGroup;
          this.costPerEvent = this.match.price/(this.calculator.playersPerEvent*this.calculator.eventsPerYear/12);
        }
        this.calculatingMatch = false;
        
      });
  }

  joinNow(){
    var dialogRef = this.dialog.open( CreateAccountComponent, {width: "350px"});
  }

  upgrade(){
    var groupText: string;
    switch (this.match.group_type){
      case 1:
        groupText = 'group';
        break;
      case 2:
        groupText = 'league';
        break;
      case 5:
        groupText = 'trip';
        break;
    }
    this.router.navigateByUrl("/upgrade/payment/"+groupText+'/'+this.match.group_type+'/'+this.match.id);
  }
}
